import { Stack, Title } from '@mantine/core';
import { IconCircleCheck } from '@tabler/icons-react';

export default function TerraSuccessRedirect() {
  return (
    <Stack align="center">
      <IconCircleCheck size={50} color="green" />
      <Title order={3} ta="center">
        Connessione dispositivo avvenuta con successo
      </Title>
      <Title order={5} ta="center">
        Puoi tornare all'app
      </Title>
    </Stack>
  );
}
